module.exports = __webpack_public_path__ + "static/media/collection_page_2026_btn.df478212.png";